import React from "react";
import { ArrowLeft, Compass, Sparkles } from "lucide-react";
import VibeBeeChatPanel from "../components/VibeBeeChatPanel";

const VIBEBEE_MASCOT_SRC = "/images/vibebee-mascot.webp";

export default function VibeBeePublicPage() {
  return (
    <main className="min-h-screen w-full bg-[#050610] text-white">
      <div className="pointer-events-none fixed inset-0 bg-[linear-gradient(180deg,#07101f_0%,#060712_44%,#050610_100%)]" />
      <div className="pointer-events-none fixed inset-0 bg-[linear-gradient(rgba(255,255,255,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.028)_1px,transparent_1px)] bg-[size:36px_36px] opacity-35" />

      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-6xl min-w-0 box-border flex-col px-4 py-3 sm:px-6 sm:py-4 lg:px-8">
        <header className="flex min-w-0 flex-wrap items-center justify-between gap-3 py-2">
          <a
            href="/"
            className="inline-flex min-h-[42px] min-w-0 items-center gap-2 rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-sm font-black text-white/82 backdrop-blur-xl transition hover:border-[#f0c66a]/38 hover:bg-white/[0.09]"
          >
            <ArrowLeft className="shrink-0" size={17} />
            Vibe2Nite
          </a>

          <a
            href="/app"
            className="inline-flex min-h-[42px] min-w-0 items-center gap-2 rounded-full border border-cyan-200/20 bg-cyan-300/10 px-4 py-2 text-sm font-black text-cyan-100 backdrop-blur-xl transition hover:bg-cyan-300/16"
          >
            <Compass className="shrink-0" size={17} />
            Open Guide
          </a>
        </header>

        <section className="grid min-w-0 flex-1 gap-3 pb-4 pt-3 sm:gap-5 sm:pb-6 sm:pt-5 lg:grid-cols-[0.92fr_1.08fr] lg:items-center lg:gap-8 lg:py-8">
          <div className="min-w-0 text-center lg:text-left">
            <div className="mx-auto mb-2 flex w-full max-w-[210px] justify-center sm:mb-5 sm:max-w-[330px] lg:mx-0 lg:max-w-[390px]">
              <img
                src={VIBEBEE_MASCOT_SRC}
                alt="Official VibeBee character"
                className="vibebee-float h-auto w-full object-contain drop-shadow-[0_20px_38px_rgba(255,46,196,0.24)] sm:drop-shadow-[0_24px_48px_rgba(255,46,196,0.28)]"
                width="420"
                height="420"
                decoding="async"
                fetchPriority="high"
              />
            </div>

            <p className="inline-flex max-w-full items-center gap-2 rounded-full border border-fuchsia-400/28 bg-fuchsia-500/10 px-3 py-1 text-[11px] font-black uppercase tracking-[0.22em] text-fuchsia-200">
              <Sparkles className="shrink-0" size={14} />
              VibeBee Concierge
            </p>

            <h1 className="mt-3 break-words text-3xl font-black leading-[0.95] text-white sm:mt-4 sm:text-5xl lg:text-6xl">
              Meet VibeBee 🐝
            </h1>

            <p className="mt-2 break-words text-xl font-black leading-tight text-[#f0c66a] sm:mt-3 sm:text-3xl">
              Your Costa del Sol AI guide.
            </p>

            <p className="mx-auto mt-3 max-w-xl break-words text-sm leading-6 text-white/70 sm:mt-4 sm:text-lg sm:leading-7 lg:mx-0">
              Ask what’s on, where to eat, where to drink, what’s nearby or how to get there.
            </p>
          </div>

          <VibeBeeChatPanel
            surface="public"
            title="Ask VibeBee"
            intro="Chat with the live Vibe2Nite concierge for Costa del Sol venues, what's on tonight, practical services and Take Me There directions."
            mascotSrc={VIBEBEE_MASCOT_SRC}
            polishedPublic
          />
        </section>
      </div>
    </main>
  );
}
